import { useState, useCallback } from 'react'
import useServicePortMappingsResources from '../../shared/resources/api/v1/admin/docker/useServicePortMappingsResources'

export default function useServicePortMappingsState(teamSlug, projectSlug, serviceSlug) {
  const [portMappings, setPortMappings] = useState([])
  const [loading, setLoading] = useState(true)

  const {
    all,
    create,
    update,
    destroy,
  } = useServicePortMappingsResources(teamSlug, projectSlug, serviceSlug)

  const load = useCallback(() => {
    return all()
      .then((response) => setPortMappings(response.servicePortMappings || []))
      .catch(() => setPortMappings([]))
      .finally(() => setLoading(false))
  }, [all])

  const refresh = useCallback(() => {
    return all()
      .then((response) => setPortMappings(response.servicePortMappings || []))
      .catch(() => setPortMappings([]))
  }, [all])

  const createPortMapping = useCallback((data) => {
    return create(data).then(() => refresh())
  }, [create, refresh])

  const updatePortMapping = useCallback((id, data) => {
    return update(id, data).then(() => refresh())
  }, [update, refresh])

  const destroyPortMapping = useCallback((id) => {
    return destroy(id).then(() => refresh())
  }, [destroy, refresh])

  return {
    portMappings,
    loading,
    load,
    createPortMapping,
    updatePortMapping,
    destroyPortMapping,
  }
}
